import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { DraftRequete } from '../entities/draft-requete/draft-requete.model';
import { BreadcrumbStep } from '../shared/components/breadcrumb/breadcrumb.model';
import { depotRequeteSteps } from './depot-requete.data';
import { DraftDepotRequeteService } from './draft-depot-requete.service';

// This is a 'false' component, use to refresh and go to the correct draft page
// This component is used when we call router.navigate(['/depot-requete']) from the draft modal for example
@Component({
    selector: 'jhi-load-draft',
    template: ''
})
export class LoadDraftComponent {
    steps: Array<BreadcrumbStep> = depotRequeteSteps.map((step, index) => ({
        label: step.breadTitle,
        route: `/${step.fullRoute}`,
        isActive: index === 0
    }));

    constructor(
        private router: Router,
        private draftDepotRequeteService: DraftDepotRequeteService
    ) {
        this.goToDraftAndRefreshVersion();
    }

    private goToDraftAndRefreshVersion() {
        this.draftDepotRequeteService
            .getMyDraftRequeteDetail()
            .subscribe(newDraft => {
                this.navigateToStepByIndex(newDraft);
            });
    }

    private navigateToStepByIndex(draft: DraftRequete): void {
        if (draft !== undefined) {
            const index = draft.getIndexStateFromDraft();

            if (depotRequeteSteps[index]) {
                this.router.navigate([depotRequeteSteps[index].fullRoute]);
                return;
            }
        }

        this.router.navigate([depotRequeteSteps[0].fullRoute]);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/load-draft.component.ts